<div class="space-y-6">
    <!-- Header Section -->
    <div class="flex justify-between items-center">
        <div>
            <!-- <h2 class="text-2xl font-bold text-gray-900">My Investment Portfolios</h2> -->
            <!-- <p class="text-gray-600 mt-1">Track your investment performance and manage your portfolio</p> -->
        </div>
        <div class="flex gap-3">
            <!-- <button (click)="refreshInvestments()" [disabled]="isLoading" class="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 transition-all flex items-center gap-2">
                <i-lucide name="refresh-ccw" class="h-4 w-4"></i-lucide>
                Refresh
            </button> -->
            <button (click)="onAddInvestment()"  class="bg-gradient-to-r from-amber-500 to-amber-600 text-white px-4 py-2 rounded-lg hover:from-amber-600 hover:to-amber-700 transition-all flex items-center gap-2">
                <i-lucide name="plus" class="h-4 w-4"></i-lucide>
                Add Investment
            </button>
        </div>
    </div>

    <!-- Summary Cards -->
    <div *ngIf="false">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6" *ngIf="userInvestments.length > 0">
            <div class="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
                <div class="flex items-center justify-between">
                    <div>
                        <p class="text-gray-600 text-sm">Total Invested</p>
                        <p class="text-2xl font-bold text-gray-900">{{ formatCurrency(getTotalInvestmentValue()) }}</p>
                    </div>
                    <div class="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                        <i-lucide name="trending-up" class="h-6 w-6 text-blue-600"></i-lucide>
                    </div>
                </div>
            </div>

            <div class="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
                <div class="flex items-center justify-between">
                    <div>
                        <p class="text-gray-600 text-sm">Current Value</p>
                        <p class="text-2xl font-bold text-gray-900">{{ formatCurrency(getTotalCurrentValue()) }}</p>
                    </div>
                    <div class="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                        <i-lucide name="dollar-sign" class="h-6 w-6 text-green-600"></i-lucide>
                    </div>
                </div>
            </div>

            <div class="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
                <div class="flex items-center justify-between">
                    <div>
                        <p class="text-gray-600 text-sm">Total P&L</p>
                        <p class="text-2xl font-bold" [ngClass]="{
                        'text-green-600': getTotalProfitLoss() >= 0,
                        'text-red-600': getTotalProfitLoss() < 0
                    }">
                            {{ getTotalProfitLoss() >= 0 ? '+' : '' }}{{ formatCurrency(getTotalProfitLoss()) }}
                        </p>
                    </div>
                    <div class="w-12 h-12 rounded-lg flex items-center justify-center" [ngClass]="{
                    'bg-green-100': getTotalProfitLoss() >= 0,
                    'bg-red-100': getTotalProfitLoss() < 0
                }">
                        <i-lucide [name]="getTotalProfitLoss() >= 0 ? 'arrow-up' : 'arrow-down'" class="h-6 w-6" [ngClass]="{
                        'text-green-600': getTotalProfitLoss() >= 0,
                        'text-red-600': getTotalProfitLoss() < 0
                    }"></i-lucide>
                    </div>
                </div>
            </div>

            <div class="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
                <div class="flex items-center justify-between">
                    <div>
                        <p class="text-gray-600 text-sm">Average ROI</p>
                        <p class="text-2xl font-bold text-amber-600">{{ getAverageROI() | number:'1.1-1' }}%</p>
                    </div>
                    <div class="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center">
                        <i-lucide name="percent" class="h-6 w-6 text-amber-600"></i-lucide>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Loading State -->
    <div *ngIf="isLoading" class="flex items-center justify-center py-12">
        <div class="text-center">
            <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-500 mx-auto mb-4"></div>
            <p class="text-gray-600">Loading your investments...</p>
        </div>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !isLoading" class="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
        <i-lucide name="circle-alert" class="h-12 w-12 text-red-500 mx-auto mb-4"></i-lucide>
        <h3 class="text-lg font-semibold text-red-800 mb-2">Error Loading Investments</h3>
        <p class="text-red-700 mb-4">{{ error }}</p>
        <button (click)="refreshInvestments()" class="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors">
            Try Again
        </button>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && !error && userInvestments.length === 0" class="text-center py-12">
        <i-lucide name="trending-up" class="h-16 w-16 text-gray-400 mx-auto mb-4"></i-lucide>
        <h3 class="text-xl font-semibold text-gray-900 mb-2">No Investments Yet</h3>
        <p class="text-gray-600 mb-6">Start building your investment portfolio today</p>
        <button (click)="onAddInvestment()" class="bg-gradient-to-r from-amber-500 to-amber-600 text-white px-6 py-3 rounded-lg hover:from-amber-600 hover:to-amber-700 transition-all">
            Explore Investment Opportunities
        </button>
    </div>

    <!-- My Investments Section (isPublished = false) -->
    <div *ngIf="!isLoading && !error && myInvestments.length > 0" class="mb-8">
        <h3 class="text-xl font-semibold text-gray-900 mb-4">My Investments</h3>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div *ngFor="let investment of myInvestments" class="bg-white rounded-xl shadow-sm p-6 border border-gray-100 hover:shadow-md transition-shadow">
                <!-- Portfolio Header -->
                <div class="flex items-center justify-between mb-6">
                    <div class="flex items-center space-x-3">
                        <div class="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center">
                            <i-lucide [name]="getPortfolioIcon(investment.portfolioId.name)" class="h-6 w-6 text-amber-600"></i-lucide>
                        </div>
                        <div>
                            <h3 class="text-lg font-semibold text-gray-900">{{ investment.portfolioId.name }}</h3>
                            <p class="text-sm text-gray-600">{{ investment.totalTickets }} tickets owned</p>
                        </div>
                    </div>
                    <div class="text-right">
                        <span class="px-3 py-1 rounded-full text-sm font-medium" [ngClass]="getStatusClass(investment.portfolioId.status)">
                            {{ investment.portfolioId.status }}
                        </span>
                    </div>
                </div>

                <!-- Investment Details -->
                <div class="space-y-3 mb-6">
                    <div class="flex justify-between">
                        <span class="text-gray-600">Initial Investment</span>
                        <span class="text-gray-800 font-semibold">{{ formatCurrency(investment.totalInvestedAmount) }}</span>
                    </div>
                    <div class="flex justify-between">
                        <span class="text-gray-600">Current Value</span>
                        <span class="text-gray-800 font-semibold">{{ formatCurrency(investment.currentValue) }}</span>
                    </div>
                    <!-- <div class="flex justify-between">
                        <span class="text-gray-600">Profit/Loss</span>
                        <span [ngClass]="{
                            'font-semibold text-green-600': investment.profitLoss >= 0,
                            'font-semibold text-red-600': investment.profitLoss < 0
                        }">
                            {{ investment.profitLoss >= 0 ? '+' : '' }}{{ formatCurrency(investment.profitLoss) }}
                        </span>
                    </div> -->
                    <!-- <div class="flex justify-between">
                        <span class="text-gray-600">ROI (Annual %)</span>
                        <span class="font-semibold" [ngClass]="{
                            'text-green-600': investment.actualRoiPercentage >= 0,
                            'text-red-600': investment.actualRoiPercentage < 0
                        }">
                            {{ investment.actualRoiPercentage >= 0 ? '+' : '' }}{{ investment.actualRoiPercentage | number:'1.1-1' }}%
                        </span>
                    </div> -->
                    <div class="flex justify-between">
                        <span class="text-gray-600">Issue Date</span>
                        <span class="text-gray-800 font-semibold">{{ investment.portfolioId.investmentStartDate | date:'mediumDate' }}</span>
                    </div>
                    <div class="flex justify-between">
                        <span class="text-gray-600">Closure Date</span>
                        <span class="text-gray-800 font-semibold">{{ investment.portfolioId.investmentClosureDate | date:'mediumDate' }}</span>
                    </div>
                </div>

                <!-- Action Buttons (No Download button for My Investments) -->
                <div class="flex">
                    <button (click)="showPortfolioDetails(investment)" class="flex-1 bg-gray-100 text-gray-700 py-2 rounded-lg hover:bg-gray-200 transition-colors flex items-center justify-center">
                        <i-lucide name="eye" class="h-4 w-4 mr-2"></i-lucide>
                        View Details
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- My Portfolios Section (isPublished = true) -->
    <div *ngIf="!isLoading && !error && myPortfolios.length > 0" class="mb-8">
        <h3 class="text-xl font-semibold text-gray-900 mb-4">My Portfolios</h3>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div *ngFor="let investment of myPortfolios" class="bg-white rounded-xl shadow-sm p-6 border border-gray-100 hover:shadow-md transition-shadow">
                <!-- Portfolio Header -->
                <div class="flex items-center justify-between mb-6">
                    <div class="flex items-center space-x-3">
                        <div class="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center">
                            <i-lucide [name]="getPortfolioIcon(investment.portfolioId.name)" class="h-6 w-6 text-amber-600"></i-lucide>
                        </div>
                        <div>
                            <h3 class="text-lg font-semibold text-gray-900">{{ investment.portfolioId.name }}</h3>
                            <p class="text-sm text-gray-600">{{ investment.totalTickets }} tickets owned</p>
                        </div>
                    </div>
                    <div class="text-right">
                        <span class="px-3 py-1 rounded-full text-sm font-medium" [ngClass]="getStatusClass(investment.portfolioId.status)">
                            {{ investment.portfolioId.status }}
                        </span>
                    </div>
                </div>

                <!-- Investment Details -->
                <div class="space-y-3 mb-6">
                    <div class="flex justify-between">
                        <span class="text-gray-600">Initial Investment</span>
                        <span class="text-gray-800 font-semibold">{{ formatCurrency(investment.totalInvestedAmount) }}</span>
                    </div>
                    <div class="flex justify-between">
                        <span class="text-gray-600">Current Value</span>
                        <span class="text-gray-800 font-semibold">{{ formatCurrency(investment.currentValue) }}</span>
                    </div>
                    <div class="flex justify-between">
                        <span class="text-gray-600">Profit/Loss</span>
                        <span [ngClass]="{
                            'font-semibold text-green-600': investment.profitLoss >= 0,
                            'font-semibold text-red-600': investment.profitLoss < 0
                        }">
                            {{ investment.profitLoss >= 0 ? '+' : '' }}{{ formatCurrency(investment.profitLoss) }}
                        </span>
                    </div>
                    <div class="flex justify-between">
                        <span class="text-gray-600">ROI (Annual %)</span>
                        <span class="font-semibold" [ngClass]="{
                            'text-green-600': investment.actualRoiPercentage >= 0,
                            'text-red-600': investment.actualRoiPercentage < 0
                        }">
                            {{ investment.actualRoiPercentage >= 0 ? '+' : '' }}{{ investment.actualRoiPercentage | number:'1.1-1' }}%
                        </span>
                    </div>
                    <div class="flex justify-between">
                        <span class="text-gray-600">Portfolio Ending Date</span>
                        <span class="text-gray-800 font-semibold">{{ investment.portfolioId.maturityDate ? (investment.portfolioId.maturityDate | date:'mediumDate') : '—' }}</span>
                    </div>
                </div>

                <!-- Action Buttons -->
                <div class="flex space-x-3">
                    <button (click)="showPortfolioDetails(investment)" class="flex-1 bg-gray-100 text-gray-700 py-2 rounded-lg hover:bg-gray-200 transition-colors flex items-center justify-center">
                        <i-lucide name="eye" class="h-4 w-4 mr-2"></i-lucide>
                        View Details
                    </button>
                    <button (click)="downloadPortfolioReport(investment)" class="flex-1 bg-amber-100 text-amber-700 py-2 rounded-lg hover:bg-amber-200 transition-colors flex items-center justify-center">
                        <i-lucide name="download" class="h-4 w-4 mr-2"></i-lucide>
                        Download
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Empty State for My Investments -->
    <div *ngIf="!isLoading && !error && myInvestments.length === 0 && userInvestments.length > 0" class="mb-8">
        <h3 class="text-xl font-semibold text-gray-900 mb-4">My Investments</h3>
        <div class="text-center py-8 bg-gray-50 rounded-lg">
            <i-lucide name="briefcase" class="h-12 w-12 text-gray-400 mx-auto mb-2"></i-lucide>
            <p class="text-gray-600">No active investments found</p>
        </div>
    </div>

    <!-- Empty State for My Portfolios -->
    <div *ngIf="!isLoading && !error && myPortfolios.length === 0 && userInvestments.length > 0" class="mb-8">
        <h3 class="text-xl font-semibold text-gray-900 mb-4">My Portfolios</h3>
        <div class="text-center py-8 bg-gray-50 rounded-lg">
            <i-lucide name="folder" class="h-12 w-12 text-gray-400 mx-auto mb-2"></i-lucide>
            <p class="text-gray-600">No Paying portfolios found</p>
        </div>
    </div>

    <!-- Global Empty State -->
    <div *ngIf="!isLoading && !error && userInvestments.length === 0" class="text-center py-12">
        <i-lucide name="trending-up" class="h-16 w-16 text-gray-400 mx-auto mb-4"></i-lucide>
        <h3 class="text-xl font-semibold text-gray-900 mb-2">No Invested Portfolio Found</h3>
        <!-- <p class="text-gray-600 mb-6">Start building your investment portfolio today</p> -->
        <!-- <button (click)="onAddInvestment()" class="bg-gradient-to-r from-amber-500 to-amber-600 text-white px-6 py-3 rounded-lg hover:from-amber-600 hover:to-amber-700 transition-all">
            Explore Investment Opportunities
        </button> -->
    </div>
  
</div>
  <app-investment-dialog [visible]="showInvestmentDialog"
    [allPortfolios]="allPortfolios"  [showPortfolioDropdown]="true" (close)="onDialogClose()"></app-investment-dialog>

<p-dialog 
    [(visible)]="showPortfolioDialog" 
    [modal]="true" 
    [closable]="true" 
    [dismissableMask]="true"
    (onHide)="onDialogClose()" 
    [style]="{width: '95vw', 'max-width': '1200px', 'max-height': '90vh'}"
    [contentStyle]="{'padding': '0', 'border-radius': '16px', }"
    styleClass="portfolio-details-modal"
    [showHeader]="false"
    [resizable]="false"
    [draggable]="false">
    
    <ng-container *ngIf="selectedPortfolio">
        <div class="relative bg-white overflow-y-auto max-h-[90vh]">
            <!-- Close Button -->
            <button 
                (click)="onDialogClose()" 
                class="absolute top-4 right-4 z-20 w-10 h-10 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-gray-50 transition-all">
                <i-lucide name="x" class="h-5 w-5 text-gray-600"></i-lucide>
            </button>

            <!-- Header Section with Portfolio Image -->
            <div class="relative bg-gradient-to-r from-amber-500 to-amber-600 text-white">
                <div class="flex flex-col lg:flex-row items-start gap-6 p-6 lg:p-8">
                    <!-- Portfolio Image -->
                    <div class="w-full lg:w-48 h-48 lg:h-32 bg-white/10 rounded-xl overflow-hidden flex-shrink-0">
                        <img 
                            *ngIf="selectedPortfolio.portfolioId.images?.length; else placeholderImage"
                            [src]="selectedPortfolio.portfolioId.images[0] | imageUrl" 
                            [alt]="selectedPortfolio.portfolioId.name"
                            class="w-full h-full object-cover">
                        <ng-template #placeholderImage>
                            <div class="w-full h-full flex items-center justify-center">
                                <i-lucide [name]="getPortfolioIcon(selectedPortfolio.portfolioId.name)" class="h-16 w-16 text-white/70"></i-lucide>
                            </div>
                        </ng-template>
                    </div>
                    
                    <!-- Portfolio Info -->
                    <div class="flex-1">
                        <div class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
                            <div>
                                <h2 class="text-2xl lg:text-3xl font-bold mb-2">{{ selectedPortfolio.portfolioId.name }}</h2>
                                <p class="text-amber-100 text-base lg:text-lg leading-relaxed mb-4">{{ selectedPortfolio.portfolioId.description }}</p>
                            </div>
                            
                          
                        </div>
                        
                        <!-- Status Tags -->
                        <div class="flex flex-wrap gap-2 mt-4">
                            <div class="px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full flex items-center space-x-1 text-xs">
                                <i-lucide name="shield" class="h-3 w-3"></i-lucide>
                                <span>{{ selectedPortfolio.portfolioId.riskLevel }} Risk</span>
                            </div>
                            <div class="px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full flex items-center space-x-1 text-xs">
                                <i-lucide name="calendar" class="h-3 w-3"></i-lucide>
                                <span>{{ selectedPortfolio.portfolioId.tenure }} Months</span>
                            </div>
                            <div class="px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full flex items-center space-x-1 text-xs">
                                <i-lucide name="trending-up" class="h-3 w-3"></i-lucide>
                                <span>{{ selectedPortfolio.portfolioId.roiPotential }}% Potential ROI</span>
                            </div>
                            <div class="px-3 py-1 rounded-full text-xs font-medium" 
                                 [ngClass]="getStatusClass(selectedPortfolio.portfolioId.status)">
                                {{ selectedPortfolio.portfolioId.status }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Content Section -->
            <div class="p-4 lg:p-8">
                <!-- Investment Focus -->
                <div class="mb-6" *ngIf="selectedPortfolio?.portfolioId?.investmentFocus?.length">
                    <h3 class="text-lg font-semibold text-gray-900 mb-3 flex items-center space-x-2">
                        <i-lucide name="target" class="h-5 w-5 text-amber-600"></i-lucide>
                        <span>Investment Focus</span>
                    </h3>
                    <div class="flex flex-wrap gap-2">
                        <span *ngFor="let tag of selectedPortfolio.portfolioId.investmentFocus" 
                              class="px-3 py-1 bg-amber-50 text-amber-700 rounded-lg text-sm font-medium border border-amber-200">
                            {{ tag }}
                        </span>
                    </div>
                </div>

                <!-- Main Content Grid -->
                <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
                    
                    <!-- Your Investment Performance -->
                    <div class="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl border border-green-200 p-6">
                        <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
                            <i-lucide name="trending-up" class="h-5 w-5 text-green-600"></i-lucide>
                            <span>Your Performance</span>
                        </h3>
                        <div class="space-y-4">
                            <div class="flex justify-between items-center">
                                <span class="text-sm text-gray-600">Invested Amount</span>
                                <span class="font-bold text-gray-900">{{ formatCurrency(selectedPortfolio.totalInvestedAmount) }}</span>
                            </div>
                            <div class="flex justify-between items-center">
                                <span class="text-sm text-gray-600">Current Value</span>
                                <span class="font-bold text-gray-900">{{ formatCurrency(selectedPortfolio.currentValue) }}</span>
                            </div>
                            <div class="flex justify-between items-center">
                                <span class="text-sm text-gray-600">Profit/Loss</span>
                                <span class="font-bold" [ngClass]="{
                                    'text-green-600': selectedPortfolio.profitLoss >= 0,
                                    'text-red-600': selectedPortfolio.profitLoss < 0
                                }">
                                    {{ selectedPortfolio.profitLoss >= 0 ? '+' : '' }}{{ formatCurrency(selectedPortfolio.profitLoss) }}
                                </span>
                            </div>
                            <div class="flex justify-between items-center">
                                <span class="text-sm text-gray-600">Your ROI</span>
                                <span class="font-bold text-lg" [ngClass]="{
                                    'text-green-600': selectedPortfolio.actualRoiPercentage >= 0,
                                    'text-red-600': selectedPortfolio.actualRoiPercentage < 0
                                }">
                                    {{ selectedPortfolio.actualRoiPercentage >= 0 ? '+' : '' }}{{ selectedPortfolio.actualRoiPercentage | number:'1.1-1' }}%
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- Portfolio Market Info -->
                    <div class="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl border border-blue-200 p-6">
                        <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
                            <i-lucide name="chart-pie" class="h-5 w-5 text-blue-600"></i-lucide>
                            <span>Market Overview</span>
                        </h3>
                        <div class="space-y-4">
                            <div class="flex justify-between items-center">
                                <span class="text-sm text-gray-600">Ticket Price</span>
                                <span class="font-bold text-gray-900">{{ formatCurrency(selectedPortfolio.portfolioId.ticketPrice) }}</span>
                            </div>
                            <div class="flex justify-between items-center">
                                <span class="text-sm text-gray-600">Total Tickets</span>
                                <span class="font-bold text-gray-900">{{ selectedPortfolio.portfolioId.totalTickets }}</span>
                            </div>
                            <div class="flex justify-between items-center">
                                <span class="text-sm text-gray-600">Available</span>
                                <span class="font-bold text-blue-600">{{ selectedPortfolio.portfolioId.availableTickets }}</span>
                            </div>
                            <div class="flex justify-between items-center">
                                <span class="text-sm text-gray-600">Sold</span>
                                <span class="font-bold text-gray-900">{{ selectedPortfolio.portfolioId.soldTickets }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- ROI & Timeline -->
                    <div class="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-xl border border-amber-200 p-6">
                        <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
                            <i-lucide name="clock" class="h-5 w-5 text-amber-600"></i-lucide>
                            <span>Timeline & ROI</span>
                        </h3>
                        <div class="space-y-4">
                            <div class="flex justify-between items-center">
                                <span class="text-sm text-gray-600">ROI Earned</span>
                                <span class="font-bold text-green-600">{{ formatCurrency(selectedPortfolio.roiEarnedTotal) }}</span>
                            </div>
                            <div class="flex justify-between items-center">
                                <span class="text-sm text-gray-600">ROI Available (in Wallet)</span>
                                <span class="font-bold text-blue-600">{{ formatCurrency(selectedPortfolio.roiAvailableFromThisPortfolio) }}</span>
                            </div>
                            <div class="flex justify-between items-center">
                                <span class="text-sm text-gray-600">Investment Start</span>
                                <span class="font-semibold text-gray-900 text-sm">{{ formatDate(selectedPortfolio.portfolioId.investmentStartDate) }}</span>
                            </div>
                            <div class="flex justify-between items-center">
                                <span class="text-sm text-gray-600">Closure Date</span>
                                <span class="font-semibold text-gray-900 text-sm">{{ formatDate(selectedPortfolio.portfolioId.investmentClosureDate) }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Your Investment Summary -->
                <div class="mt-6 bg-gray-50 rounded-xl p-6" *ngIf="selectedPortfolio.portfolioId.isPublished === true">
                    <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
                        <i-lucide name="user" class="h-5 w-5 text-gray-600"></i-lucide>
                        <span>Your Investment Summary</span>
                    </h3>
                    <div class="grid grid-cols-2 lg:grid-cols-4 gap-4">
                        <div class="text-center">
                            <div class="text-2xl font-bold text-gray-900">{{ selectedPortfolio.totalTickets }}</div>
                            <div class="text-xs text-gray-600 mt-1">Tickets Owned</div>
                        </div>
                        <div class="text-center">
                            <div class="text-2xl font-bold text-gray-900">{{ selectedPortfolio.investmentCount }}</div>
                            <div class="text-xs text-gray-600 mt-1">Investments Made</div>
                        </div>
                        <div class="text-center">
                            <div class="text-2xl font-bold text-amber-600">{{ selectedPortfolio.portfolioId.roiPotential }}%</div>
                            <div class="text-xs text-gray-600 mt-1">Expected ROI</div>
                        </div>
                        <div class="text-center">
                            <div class="text-2xl font-bold" [ngClass]="{
                                'text-green-600': selectedPortfolio.actualRoiPercentage >= 0,
                                'text-red-600': selectedPortfolio.actualRoiPercentage < 0
                            }">{{ selectedPortfolio.actualRoiPercentage | number:'1.1-1' }}%</div>
                            <div class="text-xs text-gray-600 mt-1">Annual ROI</div>
                        </div>
                    </div>
                </div>

                <!-- Action Buttons -->
                <div class="mt-6 flex flex-col sm:flex-row gap-3 justify-end">
                    
                    <button 
                        (click)="onDialogClose()"
                        class="flex items-center justify-center space-x-2 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-all font-medium">
                        <i-lucide name="x" class="h-4 w-4"></i-lucide>
                        <span>Close</span>
                    </button>
                </div>
            </div>
        </div>
    </ng-container> 
</p-dialog>